import React from "react";
import {message} from "antd";
import {useBaseComponent} from "../../../../base/base-component";
import server from "../../../../server";
import ContactDetailView from "./contact-detail.view";
import {fetchData, modelMapper, viewMapper} from "./action/contact-detail-action";
import {IContactDetailFormModel, IState} from "./types/contact-detail.types";
import DataLoading from "../../../../common/loading-data";

const initialState = {
    mobileNumber:{
        countryCode: "",
        number: ""
    },
    alternateMobileNumber:{
            countryCode: "",
            number: ""
    },
    alternateEmailId: "",
    presentAddress: {
        line1: "",
        line2: "",
        city: "",
        state: "",
        country: "",
        zipCode: ""
    },
    permanentAddress: {
        line1: "",
        line2: "",
        city: "",
        state: "",
        country: "",
        zipCode: ""
    },
    socialLinks: {
        linkedInProfileLink: "",
        gitHubLink: "",
        others: ""
    }
}

export interface IContactDetailProps {
    goToNextTab: () => void;
    employeeId: string;
}

const ContactDetail = (props: IContactDetailProps) => {

    const {state, updateState} = useBaseComponent<IContactDetailProps, IState>(props, {
        initialState: () => ({
            // data: {
            //     contact: {} as Contact,
            // },
            internal: {
                loading: false,
                currentTab: 0,
                isFormValid: true,
            },
            external: {}
        }),

        onInit: () => onInit()
    });

    async function onInit() {
        if (props.employeeId) {
            const data = await fetchData(props.employeeId);
            updateState('data', data);
        } else {
            message.error("Initialization failed: Employee ID not found!");
        }
    }

    // Submit and navigate to first error step if any
    async function onSubmit(data: IContactDetailFormModel) {
        if (props.employeeId) {
            let contactDetailPayload = modelMapper(data);
            console.log("contactDetailPayload: ", contactDetailPayload);
            await server.employee.contact.update(props.employeeId, contactDetailPayload);
            message.success('Contact details submitted successfully!');
            // props.goToNextTab();
        } else {
            updateState('internal.isFormValid', false);
            message.error("Please fill in all required fields!");
        }
    }

    return (
        state.data === undefined ? <DataLoading title="Contact Details"/> :
            <ContactDetailView
                loading={state.internal.loading}
                viewModel={viewMapper(state.data)}
                onSubmit={onSubmit}
                goToNextTab={props.goToNextTab}
            />
    )
}

export default ContactDetail;
